const INITIAL_STATE = {
  userRoles: [],
  franchise:[],
  customerPriceIncreaseReport:{},
  errors: {},
}
      
const getCustomerPriceIncreaseReport = (state = INITIAL_STATE, action) => {
  switch (action.type) {
  case 'GET_CUSTOMER_PRICE_INCREASE_REPORT_FRANCHISES_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, franchise: action.data }
  case 'GET_CUSTOMER_PRICE_INCREASE_REPORT_FRANCHISES_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'GET_CUSTOMER_PRICE_INCREASE_REPORT_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, customerPriceIncreaseReport: action.data }
  case 'GET_CUSTOMER_PRICE_INCREASE_REPORT_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'GET_CUSTOMER_PRICE_INCREASE_REPORT_USER_ROLES_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, userRoles: action.data }
  case 'GET_CUSTOMER_PRICE_INCREASE_REPORT_USER_ROLES_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  case 'POST_CUSTOMER_PRICE_INCREASE_REPORT_SUCCESSFULLY':
    return { ...state, ...INITIAL_STATE, customerPriceIncreaseReport: action.data }
  case 'POST_CUSTOMER_PRICE_INCREASE_REPORT_FAILED':
    return { ...state, ...INITIAL_STATE, errors: action.data }
  default:
    return { ...state }
  }
};
      
export default getCustomerPriceIncreaseReport;